import {connect} from 'react-redux';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import {getSchoolMarkers} from '../lib/MapUtil';
import SchoolMap from './SchoolMap';

const mapStateToProps = (state) => {
  const {reportSections, reportType: {value: reportTypeValue}, propertyDetail} = state;
  const reportType = state.reportType.value;
  const section = findSection(reportSections, reportTypeValue, 'SUBURB_PROFILE');

  const targetLatLng = propertyDetail.latitude && propertyDetail.longitude && {
    lat: propertyDetail.latitude,
    lng: propertyDetail.longitude,
  };

  return {
    reportType,
    targetLatLng,
    center: section.sectionData.center,
    zoom: section.sectionData.zoom,
    markers: [
      ...getSchoolMarkers(state),
    ],
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    onMapZoomChange: (value, reportType) => {
      dispatch(updateSectionValue({
        value,
        reportType,
        key: 'SUBURB_PROFILE',
        dataKeyPath: 'sectionData.zoom',
      }, true));
    },
    onMapCenterChange: (value, reportType) => {
      dispatch(updateSectionValue({
        value,
        reportType,
        key: 'SUBURB_PROFILE',
        dataKeyPath: 'sectionData.center',
      }, true));
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onMapZoomChange: (value) => {
      dispatchProps.onMapZoomChange(value, stateProps.reportType);
    },
    onMapCenterChange: (value) => {
      dispatchProps.onMapCenterChange(value, stateProps.reportType);
    },
  };

};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SchoolMap);